import { Box, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useItemTemplateSchema } from '../api/get-item-template-schema';

import { DefaultItemForm } from './forms';

export interface ItemTemplateDetailProps {
  itemTemplateId: string;
}

export const ItemTemplateDetail = ({ itemTemplateId }: ItemTemplateDetailProps) => {
  const { t } = useTranslation();

  const { data: templateSchema, isLoading, error } = useItemTemplateSchema(itemTemplateId);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography>{t('common.loading')}</Typography>
      </Box>
    );
  }

  if (error || !templateSchema) {
    return (
      <Card>
        <CardContent>
          <Typography color="error">{t('itemTemplates.detail.error')}</Typography>
        </CardContent>
      </Card>
    );
  }

  return <DefaultItemForm itemTemplate={templateSchema} mode="previewMode" />;
};
